import WhetherIconContainer from "../../Component/Icons/WhetherIcon/WhetherIcon"

const WhetherIcon = () => {
  return (
    <div className='page-body'>
      <WhetherIconContainer />
    </div>
  )
}

export default WhetherIcon